import { apiSlice } from "../../app/api/apiSlice";

export const masterApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getInfo: builder.query({
            query: () => `/user/info`,
            keepUnusedDataFor: 5,
            providesTags: ['settings'] 
        }),
        getNotifications: builder.query({
            query: () => `/user/notifications`,
            keepUnusedDataFor: 5,
            providesTags: ['notification']
        }),
        markNotificationRead: builder.mutation({
            query: id => ({ url: `/user/notifications/${id}/read`, method: 'PUT' }),
            invalidatesTags: ['notification']
        }),
        markAllNotificationsRead: builder.mutation({
            query: () => ({ url: '/user/notifications', method: 'PUT' }),
            invalidatesTags: ['notification']
        }),
        getUnreadMessages: builder.query({
            query: () => '/user/messages',
            keepUnusedDataFor: 5
        }),
        markAllMessagesRead: builder.mutation({
            query: () => ({ url: '/user/messages', method: 'PUT' })
        }),
        getMessages: builder.query({
            query: (receiverId) => `/conversations/conversation?receiverId=${receiverId}`,
            keepUnusedDataFor: 5,
            providesTags: ['message']
        }),
        changeAvatar: builder.mutation({
            query: formData => ({
                url: '/user/change/avatar',
                method: 'POST',
                body: formData
            }),
            invalidatesTags: ['avatar', 'settings']
        }),
        changeProfileName: builder.mutation({
            query: profile => ({
                url: '/user/profile',
                method: 'PUT',
                body: profile
            }),
            invalidatesTags: ['settings']
        }),
        sendEmailConfirmation: builder.mutation({
            query: formData => ({
                url: '/user/confirmation',
                method: 'PUT',
                body: formData
            }),
        }),  
        updateConfirmation: builder.mutation({
            query: formData => ({
                url: '/update/confirmation',
                method: 'PUT',
                body: formData
            }),
            invalidatesTags: ['settings']
        }),  
        createNewMessage: builder.mutation({
            query: formData => ({
                url: '/conversations',
                method: 'POST',
                body: formData
            }),
            invalidatesTags: ['message']
        }),  
        markConversationRead: builder.mutation({
            query: senderId => ({
                url: '/conversations/conversation',
                method: 'PUT',
                body: { senderId }
            })
        }),
    })
});

export const {
    useGetInfoQuery,
    useGetNotificationsQuery,
    useMarkNotificationReadMutation,
    useMarkAllNotificationsReadMutation,
    useGetUnreadMessagesQuery,
    useMarkAllMessagesReadMutation,
    useGetMessagesQuery,
    useChangeAvatarMutation,
    useChangeProfileNameMutation,
    useSendEmailConfirmationMutation,
    useUpdateConfirmationMutation,
    useCreateNewMessageMutation,
    useMarkConversationReadMutation,
} = masterApiSlice

